import React from "react";
import Icon from "../../components/icon/Icon";

const News = () => {
  return (
    <div className="nk-news-list">
      <a className="nk-news-item" href="#news" onClick={(ev) => ev.preventDefault()}>
        <div className="nk-news-icon">
          <Icon className='textYellow' name="card-view" />
        </div>
        <div className="nk-news-text">
          <p className="text-white">
            Do you know the latest update <span> A overview of our is now available on YouTube</span>
          </p>
          <Icon name="external" />
        </div>
      </a>
    </div>
  );
};

export default News;
